import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-double-check",
  "use": "icon-double-check-usage",
  "viewBox": "0 0 56 32",
  "content": "<symbol viewBox=\"0 0 56 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-double-check\">\n  <path d=\"M41.9747 3.36465L38.61 0L23.481 15.129L26.8456 18.4937L41.9747 3.36465ZM52.0925 0L26.8456 25.2468L16.871 15.296L13.5063 18.6607L26.8456 32L55.481 3.36465L52.0925 0ZM0 18.6607L13.3393 32L16.704 28.6353L3.38852 15.296L0 18.6607Z\" fill=\"#757575\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol